function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.5 4C16.6046 4 17.5 4.89543 17.5 6V24C17.5 25.1046 16.6046 26 15.5 26C14.3954 26 13.5 25.1046 13.5 24V6C13.5 4.89543 14.3954 4 15.5 4ZM4.67172 9.58579C5.45277 8.80474 6.7191 8.80474 7.50015 9.58579L10.5002 12.5858C11.8335 13.9191 11.8335 16.0809 10.5002 17.4142L7.50015 20.4142C6.71911 21.1953 5.45278 21.1953 4.67173 20.4142C3.89068 19.6332 3.89068 18.3668 4.67173 17.5858L7.25751 15L4.67172 12.4142C3.89068 11.6332 3.89068 10.3668 4.67172 9.58579ZM26.3284 9.58579C27.1095 10.3668 27.1095 11.6332 26.3284 12.4142L23.7426 15L26.3284 17.5858C27.1095 18.3668 27.1095 19.6332 26.3284 20.4142C25.5474 21.1953 24.281 21.1953 23.5 20.4142L20.5 17.4142C19.1667 16.0809 19.1667 13.9191 20.5 12.5858L23.5 9.58579C24.281 8.80474 25.5474 8.80474 26.3284 9.58579Z",
  fill: "#306bf6"
});

function SvgTransform(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransform);
export default __webpack_public_path__ + "static/media/transform.e3bc1b86.svg";
export { ForwardRef as ReactComponent };